import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/Marquee";
import CashflowModels from "@/components/CashflowModels";
import FourPillars from "@/components/FourPillars";
import Manifesto from "@/components/Manifesto";
import About from "@/components/About";
import Team from "@/components/Team";
import BlogPreview from "@/components/BlogPreview";
import CtaBand from "@/components/CtaBand";
import Newsletter from "@/components/Newsletter";

export default function Home() {
  return (
    <div className="grain relative">
      <Navbar />
      <main>
        <Hero />
        <EditorialMarquee />
        <CashflowModels />
        <FourPillars />
        <Manifesto />
        <About />
        <Team />
        <BlogPreview />
        <CtaBand />
        <Newsletter />
      </main>
      <Footer />
    </div>
  );
}
